import request from '@/config/axios'

export interface LiveReportVO {
  id?: number
  liveId?: number
  reporterUserId?: number
  reportType?: string
  title?: string
  content?: string
  /** 证据媒体 URL，逗号分隔（图片/视频） */
  picUrls?: string
  /** 联系方式（选填） */
  contact?: string
  status?: number
  handleResult?: string
  createTime?: string
}

export const page = (params: any) => request.get({ url: '/live/report/page', params })
/** 处理举报：后端将 status 置为已处理，result 写入 handleResult */
export const handle = (id: number, result: string) =>
  request.put({ url: '/live/report/handle', params: { id, result } })
